/**
   * Fixes UTF-8 mojibake (Ã© → é) from double-encoded backend strings,
   * and decodes HTML entities (&#39; → ').
   */
export function formatText(str: string): string {
  if (!str) return '';
  // Decode HTML entities (&#39; → ', &amp; → &, etc.)
  const el = document.createElement('textarea');
  el.innerHTML = str;
  const decoded = el.value;
  // Fix UTF-8 mojibake: treat each char as a Latin-1 byte and re-decode as UTF-8.
  // TextDecoder with fatal:true throws on invalid UTF-8 → keep original.
  try {
    const bytes = new Uint8Array(decoded.length);
    for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i) & 0xFF;
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return decoded;
  }
}
